<template>
    <div class="paperDetails">
        <div class="container" v-if="paperInfo && moduleQuestionList.length !== 0">
            <div class="question-container" ref="questionContainer">
                <div class="paper-title">{{ paperInfo.title }}</div>
                <div class="paper-info">
                    <div>总分: {{ paperInfo.score }}分</div>
                    <div>题目: {{ paperInfo.questionCnt }}题</div>
                </div>
                <div
                    :ref="`moduleItem${mItem.id}`"
                    class="module-item"
                    v-for="mItem in moduleQuestionList"
                    :key="mItem.id"
                >
                    <div class="module-title">
                        {{ mItem.title }}
                        <span v-if="mItem.score">(共计 {{ mItem.score }} 分)</span>
                    </div>
                    <Markdown class="module-subtitle" v-if="mItem.subtitle" :text="mItem.subtitle" />
                    <div class="module-container">
                        <div
                            :ref="`questionItem${item.id}`"
                            class="question-item"
                            v-for="item in mItem.questions"
                            :key="item.id"
                        >
                            <HeaderModule :question="item" :blankType="blankType" :complexType="complexType" />
                            <ChoiceModule :question="item" />
                            <div class="question-multiple" v-if="complexType.includes(item.type)">
                                <div
                                    class="question-multiple-item"
                                    :ref="`questionItem${item.id}-${childItem.id}`"
                                    v-for="childItem in item.childQuestions"
                                    :key="childItem.id"
                                >
                                    <HeaderModule
                                        :question="childItem"
                                        :blankType="blankType"
                                        :complexType="complexType"
                                    />
                                    <ChoiceModule :question="childItem" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <QuestionCard
                :paperInfo="paperInfo"
                :complexType="complexType"
                :moduleQuestionList="moduleQuestionList"
                @module="onChangeModule"
                @question="onChangeQuestion"
            />
        </div>
    </div>
</template>

<script>
import QuestionCard from '@/components/paper/QuestionCard'
import HeaderModule from '@/components/paper/HeaderModule'
import ChoiceModule from '@/components/paper/ChoiceModule'
import Markdown from '@/components/Markdown'
import { getQuestionBlankConfig } from '@/utils/tools'
import { getPaperBlockQuestions, getPaperInfo } from '@/api/paperApi.js'

export default {
    name: 'paperDetails',
    data() {
        return {
            paperInfo: null,
            moduleQuestionList: [],

            blankType: ['ORDER_BLANK', 'DISORDER_BLANK'],
            complexType: ['LISTENING', 'EREADING_COMPREHENSION'],
        }
    },
    components: { QuestionCard, HeaderModule, ChoiceModule, Markdown },
    created() {
        this.paperNo = this.$route.params.paperNo
        this.getPaperInfoApi()
        this.getPaperBlockQuestionsApi()
    },
    methods: {
        onChangeModule(item) {
            const offsetTop = this.$refs[`moduleItem${item.id}`][0].offsetTop
            window.scrollTo(0, offsetTop)
        },
        onChangeQuestion(item, childItem) {
            let refName = `questionItem${item.id}`
            if (childItem) {
                refName += `-${childItem.id}`
            }
            const offsetTop = this.$refs[refName][0].offsetTop - 50
            window.scrollTo(0, offsetTop)
        },
        getPaperInfoApi() {
            getPaperInfo({
                paperNo: this.paperNo,
            }).then((res) => {
                document.title = res.data.title
                this.paperInfo = res.data
            })
        },
        getPaperBlockQuestionsApi() {
            getPaperBlockQuestions({
                paperNo: this.paperNo,
            }).then((res) => {
                const { blankType, complexType } = this
                let index = 1
                res.data.forEach((mItem) => {
                    mItem.questions.forEach((item) => {
                        // 设置序号
                        if (!complexType.includes(item.type)) {
                            item.questionIndex = index
                            index = index + 1
                        }

                        if (blankType.includes(item.type)) {
                            item.userAnswer = new Array(item.childCnt)
                            // TODO 填空题格式兼容
                            if (item.content.indexOf('_____') > -1) {
                                item.titleList = item.content.split('_____')
                            } else {
                                // 提取配置宽度
                                item.titleList = item.content.split(/BLANK__\d+/)
                                item.blankConfig = getQuestionBlankConfig(item.content)
                            }
                        } else if (complexType.includes(item.type) && item.childQuestions) {
                            item.childQuestions.forEach((child) => {
                                // 设置序号
                                if (!complexType.includes(child.type)) {
                                    child.questionIndex = index
                                    index = index + 1
                                }
                                if (blankType.includes(child.type)) {
                                    child.userAnswer = new Array(child.childCnt)
                                    // TODO 填空题格式兼容
                                    if (child.content.indexOf('_____') > -1) {
                                        child.titleList = child.content.split('_____')
                                    } else {
                                        // 提取配置宽度
                                        child.titleList = child.content.split(/BLANK__\d+/)
                                        child.blankConfig = getQuestionBlankConfig(child.content)
                                    }
                                }
                            })
                        }
                    })
                })
                this.moduleQuestionList = res.data
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/paper.scss';

.paperDetails {
    width: 100%;
    background: #f7f7f7;
    .container {
        width: $center-width;
        margin: 0 auto;
        padding: 24px 0;
        box-sizing: border-box;
    }
}

@media screen and (max-width: 1000px) {
    .paperDetails {
        .container {
            width: auto;
            padding: 24px 12px;
        }

        .question-container {
            padding: 12px;
            width: calc(100% - 250px);
            box-sizing: border-box;
        }
    }
}
</style>
